<template>
  <div class="table-empty">
    <div class="i-rank-empty"></div>
    <div class="mt-12 mb-28">暂无相关数据</div>
  </div>
</template>

<script>
export default {
  name: 'tableEmpty',
}
</script>

<style lang="less" scoped>
.table-empty {
  font-size: 14px;
  color: #999;
  line-height: 20px;
  padding-top: 12px;
}
</style>
